<template>
  <div>
    <b-navbar variant="primary" type="dark" class="mb-5">
      <b-container>
        <b-navbar-brand to="/">
          <img class="logo" src="../assets/livevote_logo.svg" alt="LiveVOTE" />
        </b-navbar-brand>

        <b-navbar-nav v-if="this.$store.getters.isAuthenticated">
          <b-nav-item to="/admin">Admin</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-button v-if="this.$store.getters.isAuthenticated" variant="light" @click="logout">Välju</b-button>
        </b-navbar-nav>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "HeaderMain",
  methods: {
    logout() {
      this.$store.dispatch('authLogout')
        .then(() => {
          this.$router.push("/");
        });
    }
  }
};
</script>
